
import { defineComponent, ref, computed, PropType, reactive } from 'vue'

import AppDropdown from '@/components/atoms/AppDropdown.vue'
import FlexibleContent from '@/components/layout/FlexibleContent.vue'

import LocationSearch from '@/components/route/LocationSearch.vue'
import RoutePlaces from '@/components/route/RoutePlaces.vue'
import RouteStats from '@/components/route/RouteStats.vue'
import Confirm from '@/components/modals/Confirm.vue'

import { store } from '@/store'
import { GA } from '@/api/analytics'

import { Route, PlaceModel, Location } from '@/api/tripply/models'

export default defineComponent({
  name: 'Route',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  components: { AppDropdown, FlexibleContent, LocationSearch, RoutePlaces, RouteStats, Confirm },
  setup(props) {
    const state = reactive({
      editName: false,
      saving: false,
      settings: false,
      confirmDelete: false
    })
    const newName = ref('')
    const minimizePlaces = ref(false)

    const user = store.user.get(state => state.user)
    const plan = computed(() => store.user.getPlan())
    const isOwner = computed(() => store.user.isOwner(props.route.id))

    const showAssignDriver = ref(false)

    const locked = computed(() => isOwner.value && store.route.placeLimitExceeded(props.route.id))

    const addLocation = async (location: Location) => {   
      const place = new PlaceModel(location)   
      store.route.addPlace(props.route.id, place)
      GA('add_place', { method: 'search', number: 1 })   
    }

    async function save() {
      state.saving = true
      await store.route.saveRoute(props.route.id)
      state.saving = false
    }

    function updateName(e: any) {
      store.route.updateSettings(props.route.id, {name: e.target.value as string})
    }

    function goLive() {
      store.route.goLive(props.route.id)
    }

    function remove() {
      store.route.deleteRoute(props.route.id)
    }

    function exportCsv() {
      store.route.exportRoute(props.route.id)
    }

    function printRoute() {
      window.print()
    }

    function openSettings() {
      store.ui.mutate(state => state.route.settingsDrawer = !state.route.settingsDrawer)
      // store.modal.showModal('RouteSettings', {route: props.route})
    }
    function openPlaceImporter() {
      store.modal.showModal('PlaceImporter', {routeId: props.route.id})
    }
    function shareRoute() {
      store.route.share(props.route.id)
    }

    return { store, state, user, plan, save, locked, isOwner, updateName, openPlaceImporter, shareRoute, addLocation, remove, newName, openSettings, showAssignDriver, exportCsv, goLive, printRoute, minimizePlaces }
  },
})
